import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-medium text-teal-500"
}
const _hoisted_2 = {
  key: 1,
  class: "font-medium text-red-500"
}
const _hoisted_3 = { class: "grid ml-0 mr-0" }
const _hoisted_4 = { class: "col-4 pl-0 pr-1 pb-0" }
const _hoisted_5 = { style: {"width":"7rem"} }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "col-8 pl-0 pr-1 pb-0 flex flex-wrap" }
const _hoisted_8 = { class: "flex w-12 md:w-8 lg:w-8 p-1" }
const _hoisted_9 = { class: "field w-3 mb-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1 font-medium",
  for: "req-prof-code"
}, "Kód", -1)
const _hoisted_11 = {
  id: "req-prof-code",
  class: "flex align-items-center"
}
const _hoisted_12 = { class: "field w-9 mb-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1 font-medium",
  for: "req-prof-name"
}, "Názov", -1)
const _hoisted_14 = {
  id: "req-prof-name",
  class: "flex align-items-center"
}
const _hoisted_15 = { class: "flex w-12 md:w-4 lg:w-4 p-1" }
const _hoisted_16 = { class: "field w-6 mb-1" }
const _hoisted_17 = {
  class: "mb-1 font-medium",
  for: "req-prof-color"
}
const _hoisted_18 = {
  id: "req-prof-color",
  class: "flex align-items-center"
}
const _hoisted_19 = { class: "field w-6 mb-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1 font-medium",
  for: "req-prof-pc"
}, "Počet kusov", -1)
const _hoisted_21 = {
  id: "req-prof-pc",
  class: "flex align-items-center"
}
const _hoisted_22 = { class: "flex justify-content-center" }
const _hoisted_23 = { class: "w-6 pt-1 pl-1 pr-2 pb-1 flex justify-content-center" }
const _hoisted_24 = {
  key: 0,
  class: "w-6 pt-1 pl-2 pr-1 pb-1 flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.requestProfiles, (reqProf, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "w-full"
    }, [
      _createVNode(_component_Fieldset, {
        style: _normalizeStyle(`${reqProf.executed ? 'border:3px solid rgb(20, 184, 166)' : 'border:3px solid rgb(255, 0, 0)'}`),
        class: "multipack"
      }, {
        legend: _withCtx(() => [
          (reqProf.executed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(this.$props.typ == 1 ? 'Rezervované' : 'Prestriekané'), 1))
            : _createCommentVNode("", true),
          (!reqProf.executed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(this.$props.typ == 1 ? 'Nerezervované' : 'Neprestriekané'), 1))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: reqProf.product.image,
                  style: _normalizeStyle(`${reqProf.imageHeight >= reqProf.imageWidth ? 'height:60px;' : 'width:115px;'}`),
                  alt: reqProf.product.image,
                  class: "shadow-4 border-round"
                }, null, 12, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, _toDisplayString(reqProf.product.code), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, _toDisplayString(reqProf.product.name), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(this.$props.typ == 1 ? 'Farba' : 'Nová farba'), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                      class: "color-box mr-1",
                      style: _normalizeStyle({ backgroundColor: reqProf.color.colorHash })
                    }, null, 4),
                    _createElementVNode("div", null, _toDisplayString(reqProf.color.code), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, _toDisplayString(reqProf.numberOfPieces), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_PrimevueButton, {
                onClick: ($event: any) => ($options.confirmReqProfReserve(reqProf)),
                label: !reqProf.executed ? (this.$props.typ == 1 ? 'Označiť za rezervované' : 'Označiť za prestriekané') : 'Vrátiť označenie' ,
                severity: !reqProf.executed ? 'success' : 'warning',
                icon: !reqProf.executed ? 'pi pi-check' : 'pi pi-undo' ,
                text: "",
                raised: "",
                class: "w-12 md:w-10 uppercase"
              }, null, 8, ["onClick", "label", "severity", "icon"])
            ]),
            ($data.store.user.admin === true || $data.store.user.department.id == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _withDirectives(_createVNode(_component_PrimevueButton, {
                    onClick: ($event: any) => ($options.confirmReqProfDelete(reqProf)),
                    label: "Odstrániť",
                    severity: "danger",
                    icon: "pi pi-trash",
                    text: "",
                    raised: "",
                    class: "w-12 md:w-10 uppercase"
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      { value: `${reqProf.executed ? 
             (this.$props.typ == 1 ? 'Vyžiadanie o rezerváciu nie je možné odstrániť ak bol profil už rezervovaný' : 'Vyžiadanie o prestriekanie nie je možné odstrániť ak bol profil už prestriekaný') : ''}` },
                      void 0,
                      { top: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1032, ["style"])
    ]))
  }), 128))
}